<template>
  <div @click="doEmit" class="tooltip" @mouseover="onMouseHandler">
    <span v-if="showTooltip>''" class="tooltiptext">{{ tooltip }}</span>
    <div v-if="isGreen" class="green"></div>
    <div v-if="isBlue" class="blue"></div>
    <div v-if="isRed" class="red"></div>
  </div>
  <!-- <div v-else class="red"></div> -->
</template>

<script>
import { ref, computed, onMounted } from 'vue';

export default {
  props: {
    tooltip: { type: String, default: null,  required: false },
    status:  { type: String, default: "RED", required: true,
      validator: function (value) { return ['GREEN', 'RED', 'BLUE'].includes(value); }
    },
    method: { type: Function, required: false }
  },
  emits: ['send-message'],

  setup(props, { emit }) {
    // Reactive data - convert from data() function
    const ctrlKeyStatus = ref(false)

    // Computed properties - convert from computed object
    const isGreen = computed(() => props.status === 'GREEN')
    const isBlue  = computed(() => props.status === 'BLUE')
    const isRed   = computed(() => !['GREEN', 'BLUE'].includes(props.status))
    const showTooltip = computed(() => props.tooltip > '' && ctrlKeyStatus.value)

    // Methods - convert to regular functions
    const doEmit = () => {
      emit('send-message', {status: props.status, isGreen: isGreen.value});
    }

    const onMouseHandler = (event) => { 
      ctrlKeyStatus.value = event.ctrlKey; 
    }

    // Lifecycle hook - convert mounted() to onMounted()
    onMounted(() => {
      // send info back to parent
      emit('send-message', props.status);
    })

    return {
      ctrlKeyStatus,
      isGreen,
      isBlue,
      isRed,
      showTooltip,
      doEmit,
      onMouseHandler
    }
  }
}
</script>

<style scoped>
.green{
  color: #068337;
  background-color: #068337;
  width: 5px;
  height: 5px;
  font-size: 1px;
  border-radius: 50%;
  padding: 7px 7px;
}
.red{
  color: #f7403a;
  background-color: #903333;
  width: 5px;
  height: 5px;
  font-size: 1px;
  border-radius: 50%;
  padding: 7px 7px;
}
.blue{
  color: #0066cc;
  background-color: #0066cc;
  width: 5px;
  height: 5px;
  font-size: 1px;
  border-radius: 50%;
  padding: 7px 7px;
}
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tooltiptext {
  visibility: hidden;
  max-width: 150px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
  line-height: 15px;
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>